import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";

import { RegistrationComponent } from "./registration.component";
import { MainRegistrationComponent } from "./main/main.component";
import { CreateComponent } from "./create/create.component";

import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TooltipModule } from "ngx-bootstrap/tooltip";

import {
  LocationStrategy,
  HashLocationStrategy,
  CommonModule,
} from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";

import { CreateService } from "./create/create.service";
import { LoginService } from "../login/login.service";
import { RegistrationService } from "./registration.service";
import { InviteUuidGuard } from "../guards/invite-uuid.guard";

const routes: Routes = [
  {
    path: "registration",
    component: RegistrationComponent,
    children: [
      {
        path: "create/:uuid",
        component: CreateComponent,
        canActivate: [InviteUuidGuard],
      },
      {
        path: "create",
        redirectTo: "/trial",
        pathMatch: "full",
      },
      {
        path: "join/:uuid",
        component: MainRegistrationComponent,
        canActivate: [InviteUuidGuard],
      },
      {
        path: "join",
        redirectTo: "/login",
        pathMatch: "full",
      },
    ],
  },
];

@NgModule({
  exports: [RegistrationComponent, CreateComponent],
  imports: [
    BrowserModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    TooltipModule,
    RouterModule.forRoot(routes, {}),
    RegistrationComponent,
    CreateComponent,
    MainRegistrationComponent,
  ],
  providers: [
    CreateService,
    LoginService,
    RegistrationService,
    InviteUuidGuard,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class RegistrationModule {}
